goog.require('el8.template.multiuser_access.passwordResetEmailed');
goog.require('el8.service.urls');
goog.require('el8.util.base');
goog.require('el8.uiwidget.Form');

var el8 = el8 || {};
if(!el8.multiuser_access) { el8.multiuser_access = {}; }

el8.multiuser_access.passwordResetEmailed = (function() {

    var that = {};

    var email = null;
    var success = null;
    var theForm = null;

    that.init = function(spec) {
        /**
         * Initialize the global URL service
         */
        
        if (spec.urls) { el8.service.urls.init(spec.urls); }
        
        email = spec.email;
        success = spec.success;
        var loginUrl = spec.loginUrl;
        var viewDocumentUrl = spec.viewDocumentUrl;
        
        $('.main-content').html(
            el8.template.multiuser_access.passwordResetEmailed.content({
                email: email,
                success: success,
                loginUrl: loginUrl,
                viewDocumentUrl: viewDocumentUrl
            })
        );
    };  

    return that;

})();